import React from "react";
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useCapabilitiesContext } from "../context/CapabilitiesContext";
import { Authentication } from "@siemensplm/common_utils";

export const CapabilityRouter = () => {
  const { activeCapability } = useCapabilitiesContext();
  const [routesConfig, setRoutesConfig] = useState<{
    [key: string]: React.ComponentType;
  }>({});

  useEffect(() => {
    if (activeCapability) {
      const routeDetails =
        activeCapability?.capabilityDetails.routeDetails || [];

      const details = routeDetails.reduce(
        (acc, route) => {
          const Component = activeCapability?.routesMap[route.name];
          acc[route.path] = Component;
          return acc;
        },
        {} as { [key: string]: React.ComponentType }
      );

      setRoutesConfig(details || {});
    }
  }, [activeCapability]);

  if (activeCapability && routesConfig) {
    return (
      <>
        <Routes>
          {Object.entries(routesConfig).map(([path, Component]) => (
            <Route
              key={path}
              path={path}
              element={
                <Authentication>
                  <Component />
                </Authentication>
              }
            />
          ))}
        </Routes>
      </>
    );
  }

  return null;
};
